var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OpenModalService } from './../common-theme/base-components/shared/modals/open-modal.service';
import { OnInit, Injector } from '@angular/core';
import { BaseComponent } from '../common-theme/base-components/base-component';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { Image } from './../common-theme/models/index';
var PartnersComponent = /** @class */ (function (_super) {
    __extends(PartnersComponent, _super);
    function PartnersComponent(injector, translateService, openModalService) {
        var _this = _super.call(this, injector) || this;
        _this.translateService = translateService;
        _this.openModalService = openModalService;
        _this.partners = [];
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        return _this;
    }
    PartnersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.partners = this.getPartners();
        this.subscription.add(this.translateService.onLangChange
            .subscribe(function () {
            _this.partners = _this.getPartners();
        }));
        this.setTitle('Partenerii proiectului Romanescu Park Residence');
        this.setMetaDescription("\n      Recuno\u0219tin\u021B\u0103 este o valoare important\u0103, de care nu uit\u0103m niciodat\u0103. De aceea, le mul\u021Bumim\n      partenerilor proiectului nostru pentru tot sprijinul acordat: Dobrescu Arh, Real Sol, CPM \u0219i Maur -\n      toate fiind companii de prestigiu, cu experien\u021B\u0103 \u00EEn construirea proiectelor imobiliare inedite.\n    ");
    };
    PartnersComponent.prototype.getPartners = function () {
        var partners = [];
        var _loop_1 = function (i) {
            var partner = {
                title: '',
                role: '',
                content: '',
                image: {
                    url: ''
                },
                link: ''
            };
            this_1.translateSubscription.add(this_1.translateService.get('partners.' + i + '.title')
                .subscribe(function (translatedString) {
                partner.title = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('partners.' + i + '.role')
                .subscribe(function (translatedString) {
                partner.role = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('partners.' + i + '.content')
                .subscribe(function (translatedString) {
                partner.content = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('partners.' + i + '.link')
                .subscribe(function (translatedString) {
                partner.link = translatedString;
            }));
            this_1.translateSubscription.add(this_1.translateService.get('partners.' + i + '.image.url')
                .subscribe(function (translatedString) {
                partner.image.url = translatedString;
            }));
            partners.push(partner);
        };
        var this_1 = this;
        for (var i = 0; i <= 4; i++) {
            _loop_1(i);
        }
        return partners;
    };
    PartnersComponent.prototype.openPartnerModal = function (item) {
        var image = new Image();
        image.width_320_url = item.image.url;
        this.openModalService.showPartnersContent({
            id: 0,
            name: item.title,
            description: item.content,
            image: image,
            link: item.link
        });
    };
    return PartnersComponent;
}(BaseComponent));
export { PartnersComponent };



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.ts.pre-build-optimizer.js